import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { Container, Row, Col, Button, Card, CardBody } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import ServerTable from "../../../lib/ServerTable";
import getCameraColums from "./columns/CameraColumns";
import { useAuth, useApiDelete } from "../../../hooks";
import { ConfirmModal, SuccessToolbar, ErrorToolbar } from "../../../lib/formControls";
import filterIcon from "../../../common/images/filter.png";
import { CameraDetailModal } from "./CameraDetailModal";

const formInitailData = {
    cameraType: null,
    cameraStatus: null,
  };

export default function Camera() {
  const [formData, setFormData] = useState(formInitailData);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showFilder, setShowFilder] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState('');
  const [customSearch, setCustomSearch] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  const [customerror, setCustomerror] = useState('');
  const [searchObjVal, setSearchObjVal] = useState('');
  const [tableKey, setTableKey] = useState(0);
  const { authToken } = useAuth();
  const { deleteData, loading, error } = useApiDelete('admin/roles',authToken);

  useEffect(() => {
      const searchObj = {};
      let filterTxt = '';
      if(formData?.cameraType?.value) {
        /*searchObj.cameratype = formData.cameraType.value;*/
        filterTxt = 'CameraCategory|'+formData.cameraType.value;
      }

      if(formData?.cameraStatus?.value !== undefined && formData?.cameraStatus?.value != "") {
        /*searchObj.isActive = formData.cameraStatus.value;*/
        let isActiveVal = (formData?.cameraStatus?.value == 'active') ? true : false;
        filterTxt = (filterTxt)?filterTxt+'&isActive|'+isActiveVal:'isActive|'+isActiveVal;
      }

      if(filterTxt != "") {
        searchObj.filter = filterTxt;
      }

      setSearchObjVal(searchObj);
      setTableKey(prev => prev + 1);
  }, [
    formData?.cameraType?.value,
    formData?.cameraStatus?.value
  ]);

  
  const handleDelete = (roleId) => {
        setShowConfirm(true);
        setSelectedRowId(roleId);
  };

  const handleViewDetail = (rowDetails) => {
        setRowData(rowDetails);
        setShowDetails(true);
  };

  const handleConfirm = async () => {
    let payloadObj = { id: parseInt(selectedRowId) };
    let payload = JSON.stringify(payloadObj);
    const { result, error } = await deleteData(payload);
    
    if(error) {
      setCustomerror(error);
    } else {
      setIsDeleted(true);
      setTableKey(prevKey => prevKey + 1);
    }

    setShowConfirm(false);
    setSelectedRowId('');
  };

  const handleCancel = () => {
    setShowConfirm(false);
    setSelectedRowId('');
  };

  const handleDetailCancel = () => {
    setShowDetails(false);
    setRowData([]);
  };

  const handleSearchChange = (e) => {
    setCustomSearch(e.target.value);
  };


  const columns = getCameraColums(handleDelete, handleViewDetail);

  const handleChange = (selectedOption, actionMeta) => {
    setFormData(prev => ({
      ...prev,
      [actionMeta.name]: selectedOption
    }));
  };

  const cameraTypeOptions = [
    { value: "", label: "All Camera Type" },
    { value: "in", label: "In Camera" },
    { value: "out", label: "Out Camera" },
  ];

  const camereStatusOptions = [
    { value: "", label: "All Status" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  return (<div className="camera-management-page">
          <Container fluid>
            <div className='page-title-main'>
              <h5 className='page-title'>Camera Management</h5>
              <p className='page-info'>Monitor IN & OUT cameras and vehicle entries.</p>
            </div> 
            <div className='page-content-main'>
              {isDeleted && <SuccessToolbar message="🎉 Role have been deleted successfully." />}
              {customerror && <ErrorToolbar message={`⚠️ ${customerror}`} />}
              
              <div className='filter-action-main'>
                    <Row className="mb-2">
                        <Col xs={12} sm={6} md={8}>
                            <div className='input-filter-action'>
                                <input type="text" id="customSearch" name='customSearch' placeholder="Search by camera & bunk name" value={customSearch} onChange={handleSearchChange} />
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={2} className='apply-mgtp-mbl'>
                            <div className='create-record-action filter-action-slt'>
                                <Select
                                  name="cameraType"
                                  options={cameraTypeOptions}
                                  value={formData.cameraType}
                                  onChange={handleChange}
                                  placeholder={"Select Camera Type"}
                                  className='custom-react-sltbx'
                                  classNamePrefix="custom-react-sltbx"
                                />
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={2} className='apply-mgtp-mbl'>
                            <div className='create-record-action filter-action-slt'>
                                <Select
                                  name="cameraStatus"
                                  options={camereStatusOptions}
                                  value={formData.cameraStatus}
                                  onChange={handleChange}
                                  placeholder={"Select Status"}
                                  className='custom-react-sltbx'
                                  classNamePrefix="custom-react-sltbx"
                                />
                            </div>
                        </Col>
                    </Row>
              </div>

              <Row>
                <Col xs="12">
                      <div className='tablelist-maindiv'>
                          <ServerTable
                            key={tableKey}
                            apiUrlTxt="camera"
                            columns={columns}
                            customParams={searchObjVal}
                            showSearch={false}
                            showAddBtn={false}
                            addBtn={{ label: '', url: `` }}
                            srlNumbr={false}
                            customSearch={true}
                            customSearchTxt={customSearch}
                          />
                      </div>
                
                </Col>
              </Row>
            </div>   

            <CameraDetailModal
              show={showDetails}
              onHide={handleDetailCancel}
              resultdata={rowData}
            />

          </Container>
        </div>);
}
